/* RSC Health - unified Add to Cart for the whole storefront.
   ONE delegated listener handles every RSC "add" button - home & browse hot cards,
   campaign featured panels, thank-you same-draw add-ons, and the product page's related
   panels - so the behavior is identical everywhere: add the variant via /cart/add.js,
   then go straight to /cart (the behavior David chose). It NEVER fails silently: if a
   test can't be added (a draft/unavailable product, or a network error) it shows a
   visible message with the Care Advisor line instead of doing nothing.

   Handled: .cs-add[data-variant-id], [data-rel-add][data-variant-id], [data-rsc-atc][data-variant-id].
   NOT handled here: the cart page's own quantity / upgrade controls (data-rsc-add), which
   reload the cart in place (rsc-cart.js), and the product page's MAIN buy form
   (rsc-product.js), which already adds + redirects to /cart. No PHI. */
(function () {
  'use strict';
  var SEL = '.cs-add[data-variant-id],[data-rel-add][data-variant-id],[data-rsc-atc][data-variant-id]';
  var PHONE = '(866) 873-0879';

  function showError(btn, text) {
    var next = btn.nextElementSibling;
    var m = (next && next.classList && next.classList.contains('rsc-atc-msg')) ? next : null;
    if (!m) {
      m = document.createElement('span');
      m.className = 'rsc-atc-msg';
      m.setAttribute('role', 'alert');
      btn.insertAdjacentElement('afterend', m);
    }
    m.textContent = text;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    var original = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (r.ok) { window.location.assign('/cart'); return; }   // one behavior everywhere → go to cart
      return r.json().catch(function () { return {}; }).then(function (d) {
        throw new Error((d && (d.description || d.message)) || 'unavailable');
      });
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      btn.textContent = original;
      showError(btn, 'This test isn’t available to buy online yet. Call ' + PHONE + ' and a Care Advisor will help.');
    });
  });
})();
